// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"e0043f7a","787":"bfc826ba"}[chunkId] + ".chunk.js";
};